module.exports = __webpack_public_path__ + "static/media/get-gift.74ddac80.png";